import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { logout } from 'actions/User';

import styled from 'styled-components';

const PageTitleWrapper = styled.div`
  position: sticky;
  background: #fff;
  top: ${props => props.stickyTop};
  box-shadow: 0 -18px 0px #fff;
  border-bottom: ${props =>
    props.borderBottom ? '1px solid #F0F3F6' : 'none'};
  padding: ${props => (props.subtitle ? '32px 0 14px' : '32px 0')};
  z-index: 4;

  @media only screen and (max-width: 768px) {
    padding: 42px 0 4px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;

  .dropdown-toggle,
  h1 {
    display: inline-block;
    padding: 0;
    white-space: normal;

    font-family: Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 0px;
    color: #333333;
  }

  .dropdown-item {
    color: #333;
    font-size: 14px;
    line-height: 16px;
    padding: 4px 16px;
    > a {
      display: block;
      color: #333;
      &:hover {
        text-decoration: none;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .dropdown-toggle,
    .dropdown span,
    h1 {
      font-size: 20px;
    }

    .dropdown span svg {
      font-size: 13px;
    }
  }
`;

const SubTitle = styled.h4`
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  color: #767676;

  @media only screen and (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 22px;
  }
`;

const ImgLogo = styled.img`
  max-width: 136px;
  max-height: 56px;
`;

const BackButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
`;

const BackButton = styled.button`
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: #767676;
  padding: 0;
  border: none;
  background: none;
  margin-bottom: 17px;
`;

const PageTitle = ({
  title,
  subtitle,
  centerImage,
  centerImageTitle,
  rightImage,
  rightImageTitle,
  onRightImageClick,
  backTo,
  borderBottom
}) => {
  const pageTitleRef = useRef();

  const [stickyTop, setStickyTop] = useState(0);

  useEffect(() => {
    setStickyTop(pageTitleRef.current.getBoundingClientRect().top);
  }, []);

  return (
    <PageTitleWrapper
      ref={pageTitleRef}
      stickyTop={`${stickyTop}px`}
      subtitle={subtitle}
      hasBackButton={backTo ? true : false}
      borderBottom={borderBottom}
    >
      {backTo && (
        <BackButtonWrapper>
          <Link to={backTo}>
            <BackButton data-testid="backButton">
              <FontAwesomeIcon icon={faArrowLeft} /> Back
            </BackButton>
          </Link>
        </BackButtonWrapper>
      )}

      <Row>
        <Col sm={centerImage ? 5 : 10}>
          <Title data-testid="titleComponent">
            {typeof title === 'string' ? <h1>{title}</h1> : title}
          </Title>
          <SubTitle data-testid="subTitle">{subtitle}</SubTitle>
        </Col>
        {centerImage && (
          <Col sm={2} className="text-center d-none d-sm-block">
            <ImgLogo src={centerImage} alt={centerImageTitle} />
          </Col>
        )}
        {rightImage && (
          <Col
            sm={{ size: 2, offset: centerImage ? 3 : 0 }}
            className="text-end d-none d-sm-block fs-exclude"
          >
            <ImgLogo
              style={{ cursor: onRightImageClick ? 'pointer' : '' }}
              onClick={onRightImageClick}
              src={rightImage}
              alt={rightImageTitle}
              data-testid="team-logo"
            />
          </Col>
        )}
      </Row>
    </PageTitleWrapper>
  );
};

export default connect(
  ({ user }) => {
    return { user };
  },
  { logout }
)(PageTitle);
